<template>
  <div class="fansAnalyse">
    <el-card shadow="never" class="card1">
      <!-- 顶部区域 -->
      <div class="top clearfix">
        <div class="fl">
          <img
            src="../../assets/images/newIcon/vipanalysis_fans_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight: 500">粉丝分析</b>
        </div>
        <!-- 右侧区域 -->
        <div class="fr">
          <p>
            <img
              src="../../assets/images/newIcon/ss_shaixuan_icon.png"
              alt=""
            />
            <el-select
              style="width: 100px"
              v-model="options1.value"
              placeholder="请选择"
              class="my-select"
            >
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              style="width: 100px"
              v-model="def2"
              placeholder="请选择"
              class="my-select2"
            >
              <el-option
                v-for="item in options2"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
              <el-date-picker
                v-if="isshow"
                v-model="value1"
                class="rqc"
                ref="int"
                type="date"
              >
              </el-date-picker>
            </el-select>
          </p>
        </div>
      </div>
      <!--下方数据区域 -->
      <ul>
        <li>
          <p style="margin-bottom: 10px">
            <span style="margin-right: 10px" class="blueBar"></span
            ><span style="font-size: 14px">累计粉丝</span>
          </p>
          <p style="margin-bottom: 15px" class="fz29">
            199<span class="fz14">人</span>
          </p>
          <div class="box">
            <div>
              <p class="txtColor fz12 mb5">日环比</p>
              <p class="dowmColr fz12" style="font-weight: bold">
                5.9% <i class="el-icon-bottom"></i>
              </p>
            </div>
            <div style="margin-left: 20px">
              <p class="txtColor fz12 mb5">日环比（按周）</p>
              <p class="upColor fz12" style="font-weight: bold">
                5.9% <i class="el-icon-top"></i>
              </p>
            </div>
          </div>
        </li>
        <li>
          <p style="margin-bottom: 10px">
            <span style="margin-right: 10px" class="blueBar"></span
            ><span style="font-size: 14px">新增粉丝</span>
          </p>
          <p style="margin-bottom: 15px" class="fz29">
            199<span class="fz14">人</span>
          </p>
          <div class="box">
            <div>
              <p class="txtColor fz12 mb5">日环比</p>
              <p class="dowmColr fz12" style="font-weight: bold">
                5.9% <i class="el-icon-bottom"></i>
              </p>
            </div>
            <div style="margin-left: 20px">
              <p class="txtColor fz12 mb5">日环比（按周）</p>
              <p class="upColor fz12" style="font-weight: bold">
                5.9% <i class="el-icon-top"></i>
              </p>
            </div>
          </div>
        </li>
        <li>
          <p style="margin-bottom: 10px">
            <span style="margin-right: 10px" class="blueBar"></span
            ><span style="font-size: 14px">流失粉丝</span>
          </p>
          <p style="margin-bottom: 15px" class="fz29">
            199<span class="fz14">人</span>
          </p>
          <div class="box">
            <div>
              <p class="txtColor fz12 mb5">日环比</p>
              <p class="dowmColr fz12" style="font-weight: bold">
                5.9% <i class="el-icon-bottom"></i>
              </p>
            </div>
            <div style="margin-left: 20px">
              <p class="txtColor fz12 mb5">日环比（按周）</p>
              <p class="upColor fz12" style="font-weight: bold">
                5.9% <i class="el-icon-top"></i>
              </p>
            </div>
          </div>
        </li>
        <li>
          <p style="margin-bottom: 10px">
            <span style="margin-right: 10px" class="blueBar"></span
            ><span style="font-size: 14px">净增粉丝</span>
          </p>
          <p style="margin-bottom: 15px" class="fz29">
            199<span class="fz14">人</span>
          </p>
          <div class="box">
            <div>
              <p class="txtColor fz12 mb5">日环比</p>
              <p class="dowmColr fz12" style="font-weight: bold">
                5.9% <i class="el-icon-bottom"></i>
              </p>
            </div>
            <div style="margin-left: 20px">
              <p class="txtColor fz12 mb5">日环比（按周）</p>
              <p class="upColor fz12" style="font-weight: bold">
                5.9% <i class="el-icon-top"></i>
              </p>
            </div>
          </div>
        </li>
      </ul>
    </el-card>
    <el-card shadow="never" class="card1 card2">
      <!-- 顶部区域 -->
      <div style="margin-bottom: 30px" class="top clearfix">
        <div class="fl">
          <img
            src="../../assets/images/newIcon/vipanalysis_trend_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight: 500">粉丝趋势图</b>
        </div>
      </div>
      <div id="fstrend"></div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //下拉表单模拟数据
      isshow: false,
      value1: null,
      def2: "本周",
      options1: [{ name: "积木云客服号" }],
      options2: [
        { name: "本周" },
        { name: "本月" },
        { name: "近90天" },
        { name: "近半年" },
        { name: "自定义" },
      ],
    };
  },
  watch: {
    value1() {
      if (this.value1) {
        this.isshow = false;
      }
    },
    def2() {
      if (this.def2 == "自定义") {
        this.isshow = true;
        this.$nextTick(() => {
          this.$refs.int.$children[0].focus();
        });
      } else {
        this.isshow = false;
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let d1 = [
        {
          data: "6.28",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.29",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.30",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        { data: "7.1", name: "新增粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.2", name: "新增粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.3", name: "新增粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.4", name: "新增粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.5", name: "新增粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.6", name: "新增粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.7", name: "新增粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.8", name: "新增粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.9", name: "新增粉丝", val: Math.ceil(Math.random() * 1000) },
        {
          data: "7.10",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.11",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.12",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.13",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.14",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.15",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.16",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.17",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.18",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.19",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.20",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.21",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.22",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.23",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.24",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.25",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.26",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.27",
          name: "新增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
      ];
      let d2 = [
        {
          data: "6.28",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.29",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.30",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        { data: "7.1", name: "流失粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.2", name: "流失粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.3", name: "流失粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.4", name: "流失粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.5", name: "流失粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.6", name: "流失粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.7", name: "流失粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.8", name: "流失粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.9", name: "流失粉丝", val: Math.ceil(Math.random() * 1000) },
        {
          data: "7.10",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.11",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.12",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.13",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.14",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.15",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.16",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.17",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.18",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.19",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.20",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.21",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.22",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.23",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.24",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.25",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.26",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.27",
          name: "流失粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
      ];
      let d3 = [
        {
          data: "6.28",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.29",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.30",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        { data: "7.1", name: "净增粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.2", name: "净增粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.3", name: "净增粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.4", name: "净增粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.5", name: "净增粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.6", name: "净增粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.7", name: "净增粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.8", name: "净增粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.9", name: "净增粉丝", val: Math.ceil(Math.random() * 1000) },
        {
          data: "7.10",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.11",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.12",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.13",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.14",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.15",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.16",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.17",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.18",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.19",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.20",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.21",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.22",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.23",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.24",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.25",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.26",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.27",
          name: "净增粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
      ];
      let d4 = [
        {
          data: "6.28",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.29",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.30",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        { data: "7.1", name: "累计粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.2", name: "累计粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.3", name: "累计粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.4", name: "累计粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.5", name: "累计粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.6", name: "累计粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.7", name: "累计粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.8", name: "累计粉丝", val: Math.ceil(Math.random() * 1000) },
        { data: "7.9", name: "累计粉丝", val: Math.ceil(Math.random() * 1000) },
        {
          data: "7.10",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.11",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.12",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.13",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.14",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.15",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.16",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.17",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.18",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.19",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.20",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.21",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.22",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.23",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.24",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.25",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.26",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "7.27",
          name: "累计粉丝",
          val: Math.ceil(Math.random() * 1000),
        },
      ];

      let data = [...d1, ...d2, ...d3, ...d4];

      const chart = new this.$chart({
        container: "fstrend",
        autoFit: true,
        height: 500,
      });
      // chart
      // .interval({
      //     theme: {
      //     defaultColor: 'red',
      //     },
      // })
      // .position(0);
      chart.data(data);
      chart.scale({
        month: {
          range: [0, 1],
        },
        temperature: {
          nice: true,
        },
      });
      chart.scale("val", {
        min: 0,
        max: 1000,
      });

      chart.tooltip({
        showCrosshairs: true,
        shared: true,
        itemTpl: `
                    <div style="margin-bottom: 10px;list-style:none;">
                    <span style="background-color:{color};" class="g2-tooltip-marker"></span>
                   <span style="display:inline-block; transform: translate(-10px, 0px);"> {name}: {value}</span>
                    </div>
                `, // 自定义 toolTip 样式
      });

      chart.axis("val", {
        label: {
          formatter: (val) => {
            return val;
          },
        },
      });

      chart
        .line()
        .position("data*val")
        .color("name", ["#5B8FF9", "#5AD8A6", "#9270CA", "#F6BD16"])
        .shape("smooth");

      //   chart.point().position("data*val").color("name").shape("circle");

      chart.render();
    },
  },
};
</script>
<style lang="less">
.fansAnalyse {
  padding: 20px;
  .card1 {
    width: 100%;
    // 顶部样式
    .top {
      margin-top: -5px;
      .fl {
        float: left;
        font-size: 16px;
        display: flex;
        b {
          margin-left: 6px;
        }
        img {
          width: 24px;
        }
      }
      .fr {
        float: right;
        color: #999999;
        font-size: 12px;
        p {
          img {
            width: 16px;
            vertical-align: middle;
            //   margin-right: 10px;
          }
        }
        .my-select {
          margin-left: 10px;
          .el-input {
            width: 130px;
          }
        }
        .my-select2 {
          margin-left: 40px;
        }
      }
    }
    //下方数据区域
    ul {
      display: flex;
      margin-top: 30px;
      justify-content: center;
      margin-left: -55px;
      li {
        width: 25%;
        padding-left: 30px;
        padding-left: 90px;
        border-right: 1px solid #e6e6e6;
        .box {
          display: flex;
        }
        &:nth-child(4) {
          border: 0;
        }
      }
    }
  }
  .card2 {
    margin-top: 10px;
    height: 570px;
  }

  //公共样式区
  .blueBar {
    display: inline-block;
    width: 4px;
    height: 12px;
    background: #327eff;
    border-radius: 2px;
  }
  .dowmColr {
    color: #19e9aa;
  }
  .upColor {
    color: #ff4343;
  }
  .txtColor {
    color: #7e858c;
  }
  .fz29 {
    font-size: 29px;
    font-weight: 600;
  }
  .fz14 {
    font-size: 14px;
  }
  .fz12 {
    font-size: 12px;
  }
  .mb5 {
    margin-bottom: 5px;
  }
}
</style>